import * as Yup from "yup";

const individualRegisterSchema = Yup.object({
  username: Yup.string()
    .required("INPUT.VALIDATION.USERNAME")
    .min(3, "INPUT.VALIDATION.USERNAME.MIN.CHARACTER")
    .max(20, "INPUT.VALIDATION.USERNAME.MAX.CHARACTER")
    .matches(/^[a-zA-Z0-9_]+$/, "INPUT.VALIDATION.USERNAME.MATCHES.CHARACTER"),
  mobile_number: Yup.string().required("INPUT.VALIDATION.MOBILENUMBER"),
  password: Yup.string()
    .required("INPUT.VALIDATION.PASSWORD")
    .min(8, "INPUT.VALIDATION.PASSWORD.MIN.CHARACTER")
    .matches(/(?=.*[0-9!@#$%^&*])/, "INPUT.VALIDATION.PASSWORD.REQUIREMENTS"),
  first_name: Yup.string().required("INPUT.VALIDATION.FIRSTNAME"),
  last_name: Yup.string().required("INPUT.VALIDATION.LASTNAME"),
  email: Yup.string().email().required("INPUT.VALIDATION.EMAIL"),
  regionId: Yup.string().required("INPUT.VALIDATION.REGION"),
  sms_opt_out: Yup.boolean()
    .nullable()
    .required("Please select Text Message opt out option"),
});
export default individualRegisterSchema;
